// extracted by mini-css-extract-plugin
module.exports = {"authContainer":"Auth_authContainer__31L6R","authWrapper":"Auth_authWrapper__2ru4c","authFormWrapper":"Auth_authFormWrapper__yhZqg"};